import React, { useRef, useState } from 'react'
import PropTypes from 'prop-types'
import { withApollo, compose } from 'react-apollo'
import { useDispatch, useSelector } from 'react-redux'
import moment from 'moment'
import {
  getAllPointRedeem
} from '../../../../modules/reward'
import {
  Card,
  Table,
  Button,
  Input,
  Icon,
  Tag,
  Avatar,
  Select,
  Col,
  Row,
  Form,
  Tabs,
} from 'antd'
import { useDeepEffect } from '../../../../utils/hooks'
import _, { isEmpty } from 'lodash'
import Highlighter from 'react-highlight-words'

const initialOptions = {
  page: 0,
  size: 20,
  user: '',
  reward: '',
  desc: true
}

const RedeemPointTransaction = ({ form }) => {
  const dispatch = useDispatch()
  let searchInput = useRef(null)
  const { validateFields, getFieldDecorator } = form
  const [searchText, setSearchText] = useState('')
  const [filterOption, setFilterOption] = useState(initialOptions)

  const { allPointRedeem } = useSelector(
    (state) => ({
      allPointRedeem: state.reward.pointRedeemList,
    }),
    []
  )

  const GetDate = (d) => {
    let date = ''
    if (d !== null) {
      date = moment(d).format('DD/MM/YYYY')
    }
    return date
  }
  const GetStatusColor = (status) => {
    let color = ''
    switch (status) {
      case 'DONE':
        color = 'green'
        break
      case 'CANCEL':
        color = 'red'
        break
      case 'WAITING':
        color = 'yellow'
        break
      default:
        break
    }
    return color
  }

  async function fetch() {
    await dispatch(getAllPointRedeem(filterOption))
  }

  useDeepEffect(() => {
    fetch()
  }, [])

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            searchInput = node
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm)}
          icon="search"
          size="small"
          style={{ width: 90, marginRight: 8 }}>
          Search
        </Button>
        <Button
          onClick={() => handleReset(clearFilters)}
          size="small"
          style={{ width: 90 }}>
          Reset
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.select())
      }
    },
    render: (text) => (
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[searchText]}
        autoEscape
        textToHighlight={text && text.toString()}
      />
    )
  })

  const handleSearch = (selectedKeys, confirm) => {
    confirm()
    setSearchText(selectedKeys[0])
  }

  const handleReset = (clearFilters) => {
    clearFilters()
    setSearchText('')
  }

  const refetchData = async () => { }

  const columns = [
    {
      title: 'วันที่',
      dataIndex: 'createDate',
      key: 'createDate',
      render: (createDate) => {
        const datesubmit = GetDate(createDate)
        return (
          <span>
            {datesubmit}
          </span>
        )
      }
    },
    {
      title: 'ชื่อผู้ใช้',
      dataIndex: 'user',
      key: 'user',
      ...getColumnSearchProps('user'),
      render: (name, row) => (
        <div>
          <Row type="flex" gutter={8} align="middle">
            <Col>
              <Avatar src={row.userImage} size={48} />
            </Col>
            <Col>
              <Highlighter
                highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
                searchWords={[searchText]}
                autoEscape
                textToHighlight={name.toString()}
              />
            </Col>
          </Row>
        </div>
      )
    },
    {
      title: 'ของรางวัล',
      dataIndex: 'action',
      key: 'action',
      ...getColumnSearchProps('action'),
      render: (action) => (
        <div>
          [แลก] {action}
        </div>
      )
    },
    {
      title: 'คะแนน',
      dataIndex: 'point',
      key: 'point',
      render: (point) => {
        return (
          <span>
            <Tag color='purple' key={point}>
              - {point}
            </Tag>
          </span>
        )
      }
    },
    {
      title: 'สถานะ',
      dataIndex: 'reason',
      key: 'reason',
      render: (reason) => {
        const status = GetStatusColor(reason)
        return (
          <span>
            <Tag color={status} key={reason}>
              {reason}
            </Tag>
          </span>
        )
      }
    }
  ]
  async function onShowSizeChange(current, pageSize) {
    filterOption.size = pageSize
    setFilterOption(filterOption)
    await dispatch(getAllPointRedeem(filterOption))
    refetchData()
  }

  async function onChange(page) {
    filterOption.page = page - 1
    setFilterOption(filterOption)
    await dispatch(getAllPointRedeem(filterOption))
  }

  function onSubmit(e) {
    e.preventDefault()
    validateFields(async (err, values) => {
      if (!err) {
        if (values.reward) {
          filterOption.reward = values.reward
        } else {
          filterOption.reward = ''
        }
        if (values.user) {
          filterOption.user = values.user
        } else {
          filterOption.user = ''
        }
        filterOption.page = 0
        await dispatch(getAllPointRedeem(filterOption))
      }
    })
  }

  async function onClear() {
    filterOption.page = initialOptions.page
    filterOption.size = initialOptions.size
    filterOption.user = ''
    filterOption.reward = ''
    filterOption.desc = true
    form.resetFields()
    await dispatch(getAllPointRedeem(filterOption))
  }

  return (
    <div>
      <Form onSubmit={onSubmit} layout="inline">
        <Row type="flex" justify="end" align="middle">
          <Col>
            <Row type="flex" justify="end" gutter={8} align="middle">
              <Col>
                <Form.Item style={{ margin: 0 }} label="ค้นหาชื่อผู้ใช้">
                  {getFieldDecorator(`user`)(
                    <Input
                      style={{ width: 200 }}
                      placeholder="ชื่อผู้ใช้"
                    />
                  )}
                </Form.Item>
              </Col>
              <Col>
              <Form.Item style={{ margin: 0 }} label="ค้นหารางวัล">
                  {getFieldDecorator(`reward`)(
                    <Input
                      style={{ width: 200 }}
                      placeholder="รางวัล"
                    />
                  )}
                </Form.Item>
              </Col>
              <Col>
                <Button type="primary" htmlType="submit">
                  ค้นหา
                </Button>
              </Col>
              <Col>
                <Button type="danger" onClick={() => onClear()}>
                  เคลียร์
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
      </Form>
      {!isEmpty(allPointRedeem) && (
        <Table
          bordered
          scroll={{ x: 1000 }}
          rowKey={(record) => record.id}
          dataSource={allPointRedeem.content}
          columns={columns}
          pagination={{
            current: allPointRedeem.pageable.pageNumber + 1,
            pageSize: allPointRedeem.size,
            pageSizeOptions: ['10', '20', '50', '100'],
            showSizeChanger: true,
            onShowSizeChange: onShowSizeChange,
            onChange: onChange,
            total: allPointRedeem.totalElements
          }}
        />
      )}
    </div>
  )
}

const WrappedRedeemPointTransaction = Form.create({ name: 'RedeemPointTransaction' })(RedeemPointTransaction)
export default WrappedRedeemPointTransaction


// WEBPACK FOOTER //
// ./src/pages/PointTransaction/components/RedeemPointTransaction/index.js